import { render, staticRenderFns } from "./selectAfterSalesType.vue?vue&type=template&id=6087c5f3"
import script from "./selectAfterSalesType.vue?vue&type=script&lang=js"
export * from "./selectAfterSalesType.vue?vue&type=script&lang=js"
import style0 from "./selectAfterSalesType.vue?vue&type=style&index=0&id=6087c5f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports